import script from "./StudentsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentsTable.vue?vue&type=script&setup=true&lang=js"

import "./StudentsTable.vue?vue&type=style&index=0&id=07da5ad7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07da5ad7"]])

export default __exports__